// Imports ------------------------------------------------------------------->

// Private Definitions ------------------------------------------------------->

// Public Definitions -------------------------------------------------------->

// 1 week in milliseconds;
export const ONE_WEEK = 604800000;

export enum PageStatus {
	Loading,
	Error,
	Loaded
}

export interface PostMessageEvent extends Event {
	origin: string;
	result: string;
	data: any;
}

export class Category {
	name: string;
	count: number = 0;

	constructor(name: string, count?: number) {
		this.name = name;
		if (count) this.count = count;
	}
}

export interface AccountsUser {
	user_id: string;
	subscribed: boolean;
	email: string;
	email_subscribed: boolean;
	access_token: string;
	third_party_data: any;
}

export interface LoyaltyCard {
	cardId?: string;
	commitVersion?: number;
	createdAt?: Date;
	id?: string;
	loyaltyProgramId: number;
	name: string;
	phoneNumber?: string;
	updatedAt?: Date;
	pinNumber?: string;
	token?: string;
	registered?: boolean;
}

export interface LoyaltyProgram {
	id: number;
	name: string;
	isRebate: boolean;
	isLoadToCard: boolean;
	redemptionMethod: string;
	validationMethod: string;
	phoneRegex: string;
	pinRegex: string;
	cardRegex: string;
	cardImageUrl: string;
	largeLogoImageUrl: string;
	mediumLogoImageUrl: string;
	smallLogoImageUrl: string;
	logoBackingColour: string;
}

export interface LoyaltyProgramMerchant {
	id: number;
	loyaltyProgramId: number;
	merchantId: number;
}

export interface LoyaltyCardJSON {
	loyalty_cards: {
		card_id: string;
		commit_version: number;
		created_at: Date;
		id: string;
		loyalty_program_id: number;
		name: string;
		phone_number: string;
		updated_at: Date;
		registered: boolean;
		token: string;
	}[];
}

export interface LoyaltyProgramCoupon {
	id: number;
	loyaltyProgramId: number;
	couponId: number;
	externalId: string;
	validFrom: Date;
	validTo: Date;
	availableFrom: Date;
	availableTo: Date;
	redemptionMethod: string;
}

/* Enum of the authentication sources */
export enum AuthProvider {
	GOOGLE,
	FACEBOOK,
	EMAIL,
	PG // P&G Everyday
}

export enum AutocompleteContext {
	GLOBAL_SEARCH,
	SL
}

export type SearchMode = "sl" | "global";

	/* List of experiments */
export type Experiment = "disabled";

/* List of variants for each experiment */
export type DefaultVariants = "disabled";

export class StringEnum {
	constructor(public value: string) {}
	toString() { return this.value; }
}

export enum ClippingType {
	ITEM,
	PRINT_COUPON,
	COUPON,
	ECOM
}

export interface ClippingItemDetails {
	id: string;
	validTo: string;
	imageUrl: string;
}

export interface Clipping {
	type: ClippingType;
	merchant: string;
	merchantLogo: string;
	item: ClippingItemDetails;
}

export type ShoppingListOpVerb = "post" | "delete";
export type ShoppingListOpType = "flyer_item_clipping" | "list_item" | "photo" | "ecom_item_clipping";

export interface ShoppingListOp {
	verb: ShoppingListOpVerb;
	object: {
		type: ShoppingListOpType;
		id?: string;
		[key: string]: any;
	};
}

export interface SLSyncable {
	id: string;
	commitVersion: number;

	createOp(verb: ShoppingListOpVerb, modify?: boolean): ShoppingListOp;
}

export interface SLQuickItem {
	item: string;
	image: string;
	name: string;
	iconUrl: string;
	canonicalCategory: string;
	iconAssetName: string;
}

export enum ToastLevel {
	OK = "ok",
	WARNING = "warning",
	ERROR = "error"
}

export interface RatingObject {
	appStore: {
		rating: number;
		reviews: number;
	};
	playMarket: {
		rating: number;
		reviews: number;
	};
}
